import { z } from 'zod'
import { api } from './baseApi'
import { ROLES } from '@/common/permissions'

export const TeamMemberSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  role: z.nativeEnum(ROLES),
  locationNames: z.array(z.string()).optional(),
})

export type TeamMember = z.infer<typeof TeamMemberSchema>

export interface TeamRequestParams {
  pageSize?: number
  startAfterId?: string
  sortBy: string | null
  sortDirection: 'asc' | 'desc'
}

export interface TeamResponse {
  items: TeamMember[]
  hasMore: boolean
  lastId?: string
}

export const teamApi = {
  fetchTeam: async (params: TeamRequestParams): Promise<TeamResponse> => {
    const response = await api.get<TeamResponse>('/merchant/team', {
      params: {
        pageSize: params.pageSize,
        startAfterId: params.startAfterId,
        sortBy: params.sortBy || undefined,
        sortDirection: params.sortDirection,
      }
    })
    return response.data
  },
}

